<template>
    <div class="chat">
        <div class="chat_pc" v-bind:class="{ side_pc: sideShow, iframe: isIframe }">
            <div class="header" style="{ background: `linear-gradient(to right,  ${initData.navigationBarColor})` }">
                <div class="logo">
                    <!-- <img :src="customer.adminFace || initData.robotIcon || avator" /> -->
                    <img class="w100" :src="avator" />
                    <div>
                        <!-- <p class="company">{{ initData.titleDesc }}</p> -->
                    </div>
                    <div v-if="agentTyping" class="typing">{{ $t('customerInputIng') }}</div>
                </div>
                <div class="close">
                    <span class="off" @click="closeIframe"></span>
                    <span class="audio_icon" :class="sound ? 'open' : 'closed'" @click="openSound()"></span>
                    <span @click="closeSession" v-if="!isIframe" class="close_icon">结束会话</span>
                </div>
            </div>

            <Body></Body>
        </div>
    </div>
</template>

<script>
// import avator from "../../../static/image/custom.png";
import avator from "../../../static/image/logo.png";
import Body from "./body";
import chatApi from "../methods";
import urlParams from "../../api/urlParams";

export default {
    name: "index",
    data() {
        return {
            sound: true,
            sideShow: true,
            avator: avator,
            isIframe: false,
            customize: false,
            closeTime: 0
        };
    },
    components: {
        Body,
    },
    created() {

    },
    mounted() {
        if (urlParams("from") === "iframe") {
            this.isIframe = true;
        }
        if (urlParams("customize") === "true") {
            this.customize = true;
        }
        this.sideShow = this.$store.getters.getConfigPc.side_bar;
        document.querySelector(".chat").onclick = function (e) {
            const link = e.target.getAttribute("data-link");
            if (link) {
                window.open(link);
            }
        };
        window.addEventListener("visibilitychange", () => {
            if (!document.hidden) {
                document.title = this.initData.titleDesc || this.$t('userQuestion');
            }
        });
    },
    methods: {
        // iframe引入 缩小窗口
        closeIframe() {
            chatApi.isShowIframe = false;
            window.parent.postMessage({ hidden: true }, "*");
        },
        largeIframe() {
        },
        openSound() {
            this.sound = !this.sound;
            this.$store.dispatch("setEnablePlayAudio", this.sound);
        },
        closeSession() {
            // if (urlParams("inviteEvaluate")) {
            //     // 先提示评价
            //     chatApi.inviteEvaluate(() => {
            //         chatApi.closeChatSession();
            //         if (this.isIframe) {
            //             window.parent.postMessage({ hidden: true }, "*");
            //             window.location.reload();
            //         } else {
            //             //直接关闭窗口
            //             if (urlParams("close")) {
            //                 window.location.href = 'about:blank'
            //                 window.close();
            //             }
            //         }
            //     });
            //     return
            // }
            if (this.initData.evaluateMode) {
                chatApi.getEvaluateMsg(() => {
                    this.$store.dispatch("setConfigPc", [
                        { key: "showModal", value: true },
                        {
                            key: "evaluateModal",
                            value: true,
                        },
                    ]);
                });
            }


            chatApi.closeChatSession();
            if (this.isIframe) {
                window.parent.postMessage({ hidden: true }, "*");
                window.location.reload();
            } else {
                //直接关闭窗口
                if (urlParams("close")) {
                    window.location.href = 'about:blank'
                    window.close();
                }
            }
        },
    },
    computed: {

        agentTyping() {
            return this.$store.state.agentTyping;
        },
        initData() {
            return this.$store.state.initData;
        },
        customer() {
            return this.$store.state.customer;
        },
        userInfo() {
            return this.$store.state.userInfo;
        },
    },
};
</script>

<style scoped>
.chat_pc {
    overflow: hidden;
    position: absolute;
    z-index: 10;
    border: none;
    background: #FFFFFF;
    box-shadow: 0px 4px 36px 0px #00000026;
    border-radius: 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    flex-direction: column;
}

.iframe {
    width: 100%;
    height: 100%;
    min-width: 200px;
}

.logo .typing {
    padding: 3px 5px;
    font-size: 16px;
    color: #f3f3f3;
    width: 140px;
    vertical-align: bottom;
}

.side_pc {
    width: 900px;
}

.header {
    height: 60px;
    font-size: 0;
    display: flex;
    justify-content: space-between;
    background: #00A1E2;
}

.logo {
    flex: 7;
    text-align: left;
    overflow: hidden;
    display: flex;
}

.logo img {
    height: 26px;
    margin: 16px 10px 16px 20px;
    /* border-radius: 50%; */
}

.logo>div {
    font-size: 0;
    color: #ffffff;
    vertical-align: top;
    margin: 13px 0;
    flex: 1;
}

.robot {
    font-size: 12px;
    margin: 0;
}

.company {
    font-size: 14px;
    margin: 0;
    line-height: 36px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.audio {
    width: 0;
    height: 0;
    visibility: hidden;
}

.close {
    flex: 2;
    text-align: right;
    padding: 17px 20px;
}

.close span {
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
}

.close .off {
    width: 30px;
    height: 22px;
    display: none;
    background-size: 145% 132%;
    background-position: -10px -6px;
    background-image: url("../../../static/image/closeIframe.png");
}

.close .large {
    display: none;
    width: 30px;
    height: 30px;
    background-size: 100% 100%;
    margin: 0 5px;
    background-image: url("../../../static/image/largeIframe.png");
}

.iframe .off,
.iframe .large {
    display: inline-block;
}

.iframe .audio_icon {
    display: none;
}

.close_icon {
    text-align: center;
    font-size: 12px;
    color: #00A1E2;
    background: #ffffff;
    line-height: 26px;
    height: 26px;
    width: 68px;
    border-radius: 5px;
}

.close_icon::before {
    /* content: "\2716"; */
}

.audio_icon {
    width: 25px;
    height: 25px;
    background-image: url("../../../static/image/icon_ui.png");
    margin: auto 15px;
}

.open {
    background-position: -230px -94px;
}

.closed {
    background-position: -256px -94px;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/index.vue